// @flow
import React, { Component } from "react"
import { connect } from "react-redux"
import { Motion, spring, presets } from "react-motion"
import { push } from "react-router-redux"
import { Helmet } from "react-helmet"
import { SubmissionError } from "redux-form"
import {
  Modal,
  Content,
  Body,
  Header,
  Footer,
  PrimaryHeading,
  SubHeading,
  FooterLink
} from "../UI/Modal"
import Loader from "../UI/Loader"
import { sendMagicLink } from "../Auth"
import ForgotForm from "./ForgotForm"

type ForgotValues = { email: string }

type State = { loading: boolean, complete: boolean, email: string }
class Forgot extends Component<any, State> {
  constructor(props) {
    super(props)
    this.state = { loading: false, complete: false, email: "" }
  }

  async handleSubmit(values: ForgotValues) {
    const { email } = values
    this.setState(() => ({ loading: true }))
    let json: ?Object = null
    let error: ?Error = null
    try {
      json = await sendMagicLink(email)
    } catch (err) {
      error = new SubmissionError({
        _error: "Could not connect."
      })
    }
    if (json && !json.success) {
      error = new SubmissionError({
        _error: "There was a problem finding this account."
      })
    }
    this.setState(() => ({ loading: false }))
    if (error) {
      throw error
    } else {
      this.setState(() => ({ complete: true, email }))
    }
  }

  render() {
    const { loading, complete, email } = this.state
    return (
      <Modal>
        <Helmet>
          <title>Forgot Password</title>
        </Helmet>
        <Motion
          key="body"
          defaultStyle={{ y: -100, a: 0 }}
          style={{
            y: spring(0, presets.wobbly),
            a: spring(1, presets.noWobble)
          }}
        >
          {is => (
            <Body
              style={{
                transform: `translate(0, ${is.y}px`,
                opacity: is.a
              }}
            >
              <Loader loading={loading}>
                <Header>
                  <PrimaryHeading>Kiosk Admin</PrimaryHeading>
                  <SubHeading>Forgot Your Password</SubHeading>
                </Header>
                <Content>
                  {complete ? (
                    <p>An email has been sent to {email}</p>
                  ) : (
                    <ForgotForm
                      onSubmit={(values: ForgotValues) =>
                        this.handleSubmit(values)}
                    />
                  )}
                </Content>
                <Footer>
                  <FooterLink to="/auth/login">
                    Nevermind, I don't want to do this.
                  </FooterLink>
                </Footer>
              </Loader>
            </Body>
          )}
        </Motion>
      </Modal>
    )
  }
}

export default connect(null, { push })(Forgot)



// WEBPACK FOOTER //
// ./src/PublicArea/Forgot.js